enum PhotoSize {
  Icon = 'icon',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'extra_large',
  SmallSquare = 'small_square',
  MediumSquare = 'medium_square',
  LargeSquare = 'large_square',
  SmallWide = 'small_wide',
  LargeWide = 'large_wide',
  LargerWide = 'larger_wide',
  DesktopBanner = 'desktop_banner',
  MobileBanner = 'mobile_banner',
  TrailBanner = 'trail_banner',
  SmallTrailBanner = 'small_trail_banner',
  MediumTrailBanner = 'medium_trail_banner',
  LargeTrailBanner = 'large_trail_banner'
}

export default PhotoSize;
